import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    CREATE_PROVISION_BY_SAVED_CARD,
    CREATE_PROVISION_BY_SAVED_CARD_SUCCESS,
    CREATE_PROVISION_BY_SAVED_CARD_ERROR,
}
    from "../../actions/payment"

function* createProvisionBySavedCard(action) {
    try {
       const data  = yield call(paymentService.CreateProvisionBySavedCard,action.payload)
       yield put({
        type: CREATE_PROVISION_BY_SAVED_CARD_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: CREATE_PROVISION_BY_SAVED_CARD_ERROR,error: error.data
        })
    }
}


export function* createProvisionBySavedCardWatcher() {
    yield takeLatest(CREATE_PROVISION_BY_SAVED_CARD, createProvisionBySavedCard)
}